/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_developer_api_keys_create_drawer_generate_button = /** @type {(inputs: {}) => string} */ () => {
	return `Generar Llave`
};

const en_developer_api_keys_create_drawer_generate_button = /** @type {(inputs: {}) => string} */ () => {
	return `Generate Key`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const developer_api_keys_create_drawer_generate_button = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.developer_api_keys_create_drawer_generate_button(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("developer_api_keys_create_drawer_generate_button", locale)
	if (locale === "es") return es_developer_api_keys_create_drawer_generate_button(inputs)
	return en_developer_api_keys_create_drawer_generate_button(inputs)
};
export { developer_api_keys_create_drawer_generate_button as "developer.api_keys.create_drawer.generate_button" }